import Result from "@Core/Result";
import { ServiceBase } from "@Core/ServiceBase";
import { IEmptyObject } from "@Components/shared/types";
import { IUserPrompts } from "@Models/IUserPrompt";

export default class PromptService extends ServiceBase {
    public async getUserPrompts(): Promise<Result<IUserPrompts>> {
        return await this.requestJson({
            url: `/api/UserPrompt`,
            method: "GET",
        });
    }

    public async updateUserPrompt(promptId: string, status: string): Promise<Result<IEmptyObject>> {
        return await this.requestJson({
            url: `/api/UserPrompt/${promptId}?status=${status}`,
            method: "PATCH",
        });
    }
}
